import { render, staticRenderFns } from "./ImportJobResetSetupWizard.vue?vue&type=template&id=53235c2f&scoped=true&"
import script from "./ImportJobResetSetupWizard.vue?vue&type=script&lang=ts&"
export * from "./ImportJobResetSetupWizard.vue?vue&type=script&lang=ts&"
import style0 from "./ImportJobResetSetupWizard.vue?vue&type=style&index=0&id=53235c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53235c2f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAlert,VBtn,VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VIcon,VProgressLinear,VRow,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53235c2f')) {
      api.createRecord('53235c2f', component.options)
    } else {
      api.reload('53235c2f', component.options)
    }
    module.hot.accept("./ImportJobResetSetupWizard.vue?vue&type=template&id=53235c2f&scoped=true&", function () {
      api.rerender('53235c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/import/ImportJobResetSetupWizard.vue"
export default component.exports